import React from 'react';
import registeredComponent from "utils/registeredComponent";
import {duckify, filterDuck, singleDuck} from "utils/duckify";
import {entity as checklistItems} from '../../ducks/checklistItems';
import ModalComponent from '../ModalComponent';
import {Button} from "react-bootstrap";
import {customers} from "ducks";
import {modals} from "ducks";
import './styles/data-retention.scss';
import {ensureKeyed} from 'utils'
import {bulkActionEvents} from "ducks";

class DataRetention extends React.Component {

  constructor(props) {
    super(props);
    this.setAttribute = this.setAttribute.bind(this);
    this.setConfirmationMessage = this.setConfirmationMessage.bind(this);
    this.confirm = this.confirm.bind(this);
    this.submit = this.submit.bind(this);
    this.state = {checklistItems: [], reviewData: false, confirm: false, confirmationMessage: ""}
  };


  setAttribute(e) {
    let newState = this.state;
    if (e.target.id === 'delete_review') {
      // Change the review value based on whether this checkbox is checked
      newState['reviewData'] = e.target.value === 'on'
    } else {
      // add the id of the checklist item to the array if the box is checked, else remove it
      if (e.target.checked) {
        newState['checklistItems'].push(e.target.id)
      } else {
        newState['checklistItems'] = newState['checklistItems'].filter(item => item !== e.target.id)
      }
    }
    this.setState(newState)
  };

  setConfirmationMessage(e) {
    this.setState({[e.target.id]: e.target.value})
  }

  submit() {
    const {checklistItems, reviewData} = this.state;
    const {customer, dispatch, schoolYear} = this.props;
    const token = $('meta[name="csrf-token"]').attr('content');
    fetch('/api/data_retention', {
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'X-CSRF-Token': token},
      method: 'PUT',
      body: JSON.stringify({
        review_data: reviewData,
        checklist_items: checklistItems,
        school_year_id: schoolYear.id
      })
    })
      .then(() => filterDuck(bulkActionEvents, {name: 'data_retention'}))
      .then(() => dispatch(modals.actions.hide('DataRetention')))
      .then(() => dispatch(modals.actions.show('MessageModal', {
        message: 'The specified items are being deleted. This may take some time. You may now close this modal.'
      })))
      // Update state with new audits so we don't have to refresh for the audit modal to work
      .catch((response) => dispatch(modals.actions.hide())
        .then((response) => dispatch(modals.actions.show('UnexpectedError'))))
  }

  confirm() {
    this.setState({confirm: true})
  }

  previous() {
    this.setState({confirm: false})
  }


  render() {
    const schoolYear = this.props.schoolYear;
    const {deletableItems} = this.props;
    const {confirm, confirmationMessage} = this.state;
    const buttons = confirm ? [
      <Button variant="primary"
              onClick={() => this.previous()}>{'< Previous'}</Button>,
      <Button variant="primary"
              disabled={this.state.confirmationMessage.toLowerCase() !== 'delete'}
              onClick={() => this.submit()}>{'Submit'}</Button>

    ] : [<Button variant="primary"
                className="ms-1"
                onClick={() => this.confirm()}>{'Confirm'}</Button>]

    return (<ModalComponent buttons={buttons} title={"Manage Data Retention"}>
        {!confirm ?
          <div className={'data-retention-container'}>
            <h2 className={'data-retention-title'}> Selected Term: {schoolYear.name} </h2>
            <div className={'data-retention-row'}>
              <span> This tool will <span className="red bold">PERMANENTLY</span> delete the selected data.
                Once deleted, this data is not recoverable.</span>
            </div>
            <div className={'data-retention-row'}>
              <h2 className={'data-retention-header'}> Review Data </h2>
            </div>
            <div className={'data-retention-row'}>
              <input className={'controls'} onChange={this.setAttribute} id="delete_review" type={'checkbox'}
                     checked={this.state.reviewData}/>
              <label htmlFor="delete_review" className={'data-retention-label'}> Delete ALL comments and
                scores for the selected term. </label>
            </div>
            <div className={'data-retention-row'}>

              <h2 className={'data-retention-header'}> Select Admissions Checklist Items </h2>

            </div>

            <div className={'data-retention-row'}>This will delete ALL forms and uploaded items associated with any
              selected item.
              Checklist item completion will be retained.
            </div>
            <div className={'data-retention-row'}></div>

            {deletableItems.map((item) =>
              <div className={'data-retention-row'}>
                <input className={'controls'} onChange={this.setAttribute} type={'checkbox'} id={item.id}
                       checked={this.state.checklistItems.includes(item.id)}/>
                <label htmlFor={item.id} className={'data-retention-label'}> {item.name} </label>
              </div>
            ).map(ensureKeyed())}
          </div> :
          <div className={'data-retention-container'}>
            <div className={'red confirm-submit-row'}> Once confirmed, this action cannot be undone!</div>
            <div className={'confirm-submit-row'}> Finalsite Enrollment cannot recover ANY data that has been deleted by this
              action.
            </div>
            <div> The following information will be deleted -
              {this.state.reviewData ? <li>All review data will be destroyed.</li> : ""}
              {this.state.checklistItems.map((item) => <li> All related forms and files for the
                Checklist Item <b>{deletableItems.find(x => x.id === item).name}</b> in {schoolYear.name}.
              </li>)} </div>
            <div className={'confirm-submit-row'}> To confirm action, type DELETE in the box:
              <input className={'confirm-submit-input'} onChange={this.setConfirmationMessage}
                     id='confirmationMessage'/></div>
          </div>}
      </ModalComponent>
    )
  }
}


function mapDucksToProps(props) {
  const schoolYearId = props.schoolYear.id;
  return {
    customer: singleDuck(customers, 'current'),
    deletableItems: filterDuck(checklistItems, {school_year_id: schoolYearId, type: "AdmissionsChecklistItem"})
  }
}

export default registeredComponent("DataRetention")(duckify(mapDucksToProps)(DataRetention))
